"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ads = _interopRequireDefault(require("./modules/ads"));

var _movingPage = _interopRequireDefault(require("./modules/ads/movingPage"));

var _espSync = _interopRequireDefault(require("./modules/esp-sync"));

var _collectedForms = _interopRequireDefault(require("./modules/collected-forms"));

var _form = _interopRequireDefault(require("./modules/form"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var MarketingModule = {
  route: _UrlPathParams.MARKETING,
  modules: [_ads.default, _movingPage.default, _collectedForms.default, _espSync.default, _form.default]
};
var _default = MarketingModule;
exports.default = _default;
module.exports = exports.default;